<template>
  <div class="">
    <div class="ps-3 mt-3">
      <div class="general-page">
        <div class="px-4 py-3">
          <div class="d-flex flex-wrap">
            <div class="mt-3 col-12 col-lg-6">
              <div class="input-box">
                <label class="mb-0" for="">Event Name</label>
                <input
                  type="text"
                  v-model="name"
                  @focus="nameEmpty = false"
                  v-on:keyup.enter="save()"
                  placeholder=""
                />
                <div v-if="nameEmpty" style="color: red">
                  Event Name is required
                </div>
              </div>
            </div>
            <div class="mt-3 col-12 col-lg-6">
              <div class="input-box">
                <label class="mb-0" for="">Event ID</label>
                <input
                  type="text"
                  v-model="code"
                  v-on:keyup.enter="save()"
                  @focus="codeEmpty = false"
                  placeholder=""
                />
                <div v-if="codeEmpty" style="color: red">
                  Event ID is required
                </div>
              </div>
            </div>
            <div class="mt-3 col-12 col-lg-6">
              <div class="input-box">
                <label class="mb-0" for="">Regsitration Start With</label>
                <input
                  type="text"
                  v-on:keyup.enter="save()"
                  v-model="reg_start_with"
                  @focus="reg_start_withEmpty = false"
                  placeholder=""
                />
                <div v-if="reg_start_withEmpty" style="color: red">
                  Regsitration Start With is required
                </div>
              </div>
            </div>
            <div class="mt-3 col-12 col-lg-6">
              <div class="input-box">
                <label class="mb-0" for="">Year</label>
                <input
                  type="date"
                  v-model="year"
                  @focus="yearEmpty = false"
                  placeholder=""
                />
                <div v-if="yearEmpty" style="color: red">Year is required</div>
              </div>
            </div>
            <div class="mt-3 col-12 col-lg-6">
              <div class="input-box">
                <label for="">Event Type</label>
                <select
                  class="py-0"
                  name=""
                  id=""
                  v-model="event_type"
                  @focus="event_typeEmpty = false"
                >
                  <option value="Exhibition">Exhibition</option>
                  <option value="Conference">Conference</option>
                </select>
                <div v-if="event_typeEmpty" style="color: red">
                  Event Type is required
                </div>
              </div>
            </div>
            <div class="mt-3 col-12 col-lg-6">
              <div class="input-box">
                <label for="">Conference / Exhibition Type</label>
                <select
                  class="py-0"
                  name=""
                  id=""
                  v-model="con_exh_type"
                  @focus="con_exh_typeEmpty = false"
                >
                  <option value="National">National</option>
                  <option value="International">International</option>
                </select>
              </div>
              <div v-if="con_exh_typeEmpty" style="color: red">
                Conference / Exhibition Type is required
              </div>
            </div>
            <div class="mt-3 col-12 col-lg-6">
              <div class="input-box">
                <label class="mb-0" for="">Total Hall</label>
                <input
                  type="number"
                  v-model="hall_count"
                  v-on:keyup.enter="save()"
                  @focus="hall_countEmpty = false"
                  placeholder=""
                />
              </div>
              <div v-if="hall_countEmpty" style="color: red">
                Total Hall is required
              </div>
            </div>
            <div class="mt-3 col-12 col-lg-6">
              <div class="input-box">
                <label class="mb-0" for="">Max Session/ Day</label>
                <input
                  type="number"
                  v-on:keyup.enter="save()"
                  v-model="max_session_per_day"
                  @focus="max_session_per_dayEmpty = false"
                  placeholder=""
                />
              </div>
              <div v-if="max_session_per_dayEmpty" style="color: red">
                Max Session/ Day is required
              </div>
            </div>
            <div class="mt-3 col-12 col-lg-6">
              <div class="input-box">
                <label class="mb-0" for="">Event Days</label>
                <input
                  type="number"
                  v-on:keyup.enter="save()"
                  name="event_days"
                  id="event_days"
                  v-model="event_days"
                  @input="eventDaysSelect"
                  @focus="event_daysEmpty = false"
                  placeholder=""
                />
              </div>
              <div v-if="event_daysEmpty" style="color: red">
                Event Days is required
              </div>
            </div>
          </div>

          <div class="mt-0 col-12 d-flex flex-wrap px-3" v-if="event_days">
            <div
              class="mt-3 me-5"
              v-for="(event_code, index) in event_codes"
              :key="index"
            >
              <div class="">
                <div class="all-select d-flex align-items-center">
                  <label>Day-{{ index + 1 }}</label>
                </div>
                <div class="single-select mt-2">
                  <label>
                    <input
                      type="checkbox"
                      v-model="event_code.bfast"
                      @click="setValue(index, 1)"
                    />Break Fast</label
                  >
                </div>
                <input
                  v-if="event_code.bfast == true"
                  required
                  class="food-input"
                  type="text"
                  v-on:keyup.enter="save()"
                  v-model="event_code.bfast_value"
                />

                <div class="single-select mt-1">
                  <label
                    ><input
                      type="checkbox"
                      v-model="event_code.lunch"
                      @click="setValue(index, 2)"
                    />Lunch</label
                  >
                </div>
                <input
                  v-if="event_code.lunch == true"
                  required
                  class="food-input"
                  type="text"
                  v-on:keyup.enter="save()"
                  v-model="event_code.lunch_value"
                />

                <div class="single-select mt-1">
                  <label
                    ><input
                      type="checkbox"
                      v-model="event_code.dinner"
                      @click="setValue(index, 3)"
                    />Dinner</label
                  >
                </div>
                <input
                  v-if="event_code.dinner == true"
                  required
                  class="food-input"
                  type="text"
                  v-on:keyup.enter="save()"
                  v-model="event_code.dinner_value"
                />

                <div class="single-select mt-1">
                  <label
                    ><input
                      type="checkbox"
                      v-model="event_code.other1"
                      @click="setValue(index, 4)"
                    />other 1</label
                  >
                </div>
                <input
                  v-if="event_code.other1 == true"
                  required
                  class="food-input"
                  type="text"
                  v-on:keyup.enter="save()"
                  v-model="event_code.other1_value"
                />

                <div class="single-select mt-1">
                  <label
                    ><input
                      type="checkbox"
                      v-model="event_code.other2"
                      @click="setValue(index, 5)"
                    />other 2</label
                  >
                </div>
                <input
                  v-if="event_code.other2 == true"
                  required
                  class="food-input"
                  type="text"
                  v-on:keyup.enter="save()"
                  v-model="event_code.other2_value"
                />
              </div>
            </div>
          </div>

          <div class="per-missions mt-2">
            <div class="all-select d-flex align-items-center">
              <label>
                <!-- v-model="event_days" @focus="event_daysEmpty = false" -->
                Choose Spot Register Information
              </label>
            </div>
            <div class="d-flex flex-wrap">
              <div class="single-select col-12 mt-1">
                <label
                  ><input
                    class=""
                    type="checkbox"
                    v-model="spot_register_info[0]"
                    @focus="srititleEmpty = false"
                  />Title</label
                >
              </div>
              <div class="single-select col-12 mt-1">
                <label
                  ><input
                    class=""
                    type="checkbox"
                    v-model="spot_register_info[1]"
                    @focus="srinameEmpty = false"
                  />Full Name</label
                >
              </div>
              <div class="single-select col-12 mt-1">
                <label
                  ><input
                    class=""
                    type="checkbox"
                    v-model="spot_register_info[2]"
                    @focus="sricompanyEmpty = false"
                  />Company</label
                >
              </div>
              <div class="single-select col-12 mt-1">
                <label
                  ><input
                    class=""
                    type="checkbox"
                    v-model="spot_register_info[3]"
                    @focus="sridesignationEmpty = false"
                  />Designation</label
                >
              </div>
              <div class="single-select col-12 mt-1">
                <label
                  ><input
                    class=""
                    type="checkbox"
                    v-model="spot_register_info[4]"
                    @focus="sricategoryEmpty = false"
                  />Category</label
                >
              </div>
              <div class="single-select col-12 mt-1">
                <label
                  ><input
                    class=""
                    type="checkbox"
                    v-model="spot_register_info[5]"
                    @focus="sriphotoEmpty = false"
                  />Photo</label
                >
              </div>
              <div class="single-select col-12 mt-1">
                <label
                  ><input
                    class=""
                    type="checkbox"
                    v-model="spot_register_info[6]"
                    @focus="sricityEmpty = false"
                  />City</label
                >
              </div>
              <div class="single-select col-12 mt-1">
                <label
                  ><input
                    class=""
                    type="checkbox"
                    v-model="spot_register_info[7]"
                    @focus="srimobileEmpty = false"
                  />Mobile</label
                >
              </div>
              <div class="single-select col-12 mt-1">
                <label
                  ><input
                    class=""
                    type="checkbox"
                    v-model="spot_register_info[8]"
                    @focus="sriemailEmpty = false"
                  />Email</label
                >
              </div>
            </div>
          </div>
          <div class="per-missions mt-2">
            <div class="all-select d-flex align-items-center">
              <label
                >Choose KitBag/ Certificates/ Exhibitor Directory/
                Magazine</label
              >
            </div>
            <div class="single-select mt-1">
              <label
                ><input
                  class=""
                  type="checkbox"
                  v-model="kitbag"
                  @focus="kitbagEmpty = false"
                />KitBag</label
              >
            </div>
            <div class="single-select mt-1">
              <label
                ><input
                  class=""
                  type="checkbox"
                  v-model="certificate"
                  @focus="certificateEmpty = false"
                />Certificates</label
              >
            </div>
            <div class="single-select mt-1">
              <label
                ><input
                  class=""
                  type="checkbox"
                  v-model="magazine"
                  @focus="magazineEmpty = false"
                />Exhibitor Directory / Magazine</label
              >
            </div>
          </div>
          <div class="per-missions mt-2">
            <div class="all-select d-flex align-items-center">
              <label>Payment</label>
            </div>
            <div class="single-select mt-1">
              <label>
                <input
                  type="checkbox"
                  v-model="payment"
                  @focus="paymentEmpty = false"
                />Yes</label
              >
            </div>
          </div>
          <div class="d-flex justify-content-start me-3">
            <button class="submit-btn" variant="success" @click="save()">
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "HomeView",
  components: {},
  data() {
    return {
      name: "",
      nameEmpty: false,
      code: "",
      codeEmpty: false,
      year: "",
      yearEmpty: false,
      event_type: "",
      event_typeEmpty: false,
      con_exh_type: "",
      con_exh_typeEmpty: false,
      hall_count: "",
      hall_countEmpty: false,
      max_session_per_day: "",
      max_session_per_dayEmpty: false,
      event_days: "",
      event_daysEmpty: false,
      reg_start_with: "",
      reg_start_withEmpty: false,
      kitbag: "",
      kitbagEmpty: false,
      certificate: "",
      certificateEmpty: false,
      magazine: "",
      magazineEmpty: false,
      payment: "",
      paymentEmpty: false,
      event_days: [],
      break_fast: "",
      break_fastEmpty: false,
      lunch: "",
      lunchEmpty: false,
      dinner: "",
      dinnerEmpty: false,
      event_codes: [],
      event_services: [],
      event_codesEmpty: false,
      bfast: "",
      bfastEmpty: false,
      roleSelected: "",
      spot_register_info: [
        "title",
        "fullname",
        "company",
        "designation",
        "category",
        "photo",
        "city",
        "mobile",
        "email",
      ],

      current_event_id: "",
    };
  },

  mounted() {
    if (localStorage.eventId) {
      this.current_event_id = localStorage.eventId;
      this.getEvent();
    }
  },
  methods: {
    checkbox: function (event_code) {
      if (event_code == true) {
        this.event_code.bfast = 1;
        return;
      }
    },

    eventDaysSelect() {
      this.event_codes = [];
      const formdata = new FormData();
      formdata.append("event_id", this.current_event_id);
      axios
        .post(`${this.$store.getters.baseUrl}/manage-event`, formdata, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.event_services = response.data.event_services;
            for (var i = 0; i < this.event_days; i++) {
              if (this.event_services.length > i) {
                this.event_codes.push({
                  bfast: this.event_services[i].break_fast == 1 ? true : false,
                  bfast_value: this.event_services[i].break_fast_name,
                  lunch: this.event_services[i].lunch == 1 ? true : false,
                  lunch_value: this.event_services[i].lunch_name,
                  dinner: this.event_services[i].dinner == 1 ? true : false,
                  dinner_value: this.event_services[i].dinner_name,
                  other1:
                    this.event_services[i].other_service_1 == 1 ? true : false,
                  other1_value: this.event_services[i].other_service_1_name,
                  other2:
                    this.event_services[i].other_service_2 == 1 ? true : false,
                  other2_value: this.event_services[i].other_service_2_name,
                });
              } else if (this.event_services.length <= i) {
                this.event_codes.push({
                  bfast: false,
                  bfast_value: "",
                  lunch: false,
                  lunch_value: "",
                  dinner: false,
                  dinner_value: "",
                  other1: false,
                  other1_value: "",
                  other2: false,
                  other2_value: "",
                });
              }
            }
          }
        });
    },
    setValue(index, type) {
      if (type == 1) {
        if (this.event_codes[index].bfast == true) {
          this.event_codes[index].bfast = false;
        } else {
          this.event_codes[index].bfast = true;
        }
      } else if (type == 2) {
        if (this.event_codes[index].lunch == true) {
          this.event_codes[index].lunch = false;
        } else {
          this.event_codes[index].lunch = true;
        }
      } else if (type == 3) {
        if (this.event_codes[index].dinner == true) {
          this.event_codes[index].dinner = false;
        } else {
          this.event_codes[index].dinner = true;
        }
      } else if (type == 4) {
        if (this.event_codes[index].other1 == true) {
          this.event_codes[index].other1 = false;
        } else {
          this.event_codes[index].other1 = true;
        }
      } else if (type == 5) {
        if (this.event_codes[index].other2 == true) {
          this.event_codes[index].other2 = false;
        } else {
          this.event_codes[index].other2 = true;
        }
      }
    },

    async getEvent() {
      const formdata = new FormData();
      formdata.append("event_id", this.current_event_id);

      await axios
        .post(`${this.$store.getters.baseUrl}/manage-event`, formdata, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            var event = response.data.event_Details;
            var event_services = response.data.event_services;
            this.name = event.name;
            this.code = event.code;
            this.year = event.year;
            this.event_type = event.type;
            this.con_exh_type = event.level;
            this.hall_count = event.total_hall_entry;
            this.max_session_per_day = event.max_session_per_day;
            this.event_days = event.total_days;
            this.reg_start_with = event.reg_start_with;
            this.kitbag = event.kitbag == 1 ? true : false;
            this.certificate = event.certificates == 1 ? true : false;
            this.magazine = event.magazine == 1 ? true : false;
            this.payment = event.payment == 1 ? true : false;
            // this.spot_register_info = event.spot_register_info;
            if (event.spot_register_info.includes("title")) {
              this.spot_register_info[0] = true;
            }
            if (event.spot_register_info.includes("fullname")) {
              this.spot_register_info[1] = true;
            }
            if (event.spot_register_info.includes("company")) {
              this.spot_register_info[2] = true;
            }
            if (event.spot_register_info.includes("designation")) {
              this.spot_register_info[3] = true;
            }
            if (event.spot_register_info.includes("category")) {
              this.spot_register_info[4] = true;
            }
            if (event.spot_register_info.includes("photo")) {
              this.spot_register_info[5] = true;
            }
            if (event.spot_register_info.includes("city")) {
              this.spot_register_info[6] = true;
            }
            if (event.spot_register_info.includes("mobile")) {
              this.spot_register_info[7] = true;
            }
            if (event.spot_register_info.includes("email")) {
              this.spot_register_info[8] = true;
            }
            for (var i = 0; i < event_services.length; i++) {
              this.event_codes.push({
                bfast: event_services[i].break_fast == 1 ? true : false,
                bfast_value: event_services[i].break_fast_name,
                lunch: event_services[i].lunch == 1 ? true : false,
                lunch_value: event_services[i].lunch_name,
                dinner: event_services[i].dinner == 1 ? true : false,
                dinner_value: event_services[i].dinner_name,
                other1: event_services[i].other_service_1 == 1 ? true : false,
                other1_value: event_services[i].other_service_1_name,
                other2: event_services[i].other_service_2 == 1 ? true : false,
                other2_value: event_services[i].other_service_2_name,
              });
            }
            console.log("event_co", this.event_codes);
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },

    async save() {
      if (this.name == "") {
        this.nameEmpty = true;
        return;
      }
      if (this.code == "") {
        this.codeEmpty = true;
        return;
      }
      if (this.year == "") {
        this.yearEmpty = true;
        return;
      }
      if (this.event_type == "") {
        this.event_typeEmpty = true;
        return;
      }
      if (this.con_exh_type == "") {
        this.con_exh_typeEmpty = true;
        return;
      }
      if (this.hall_count == "") {
        this.hall_countEmpty = true;
        return;
      }
      if (this.max_session_per_day == "") {
        this.max_session_per_dayEmpty = true;
        return;
      }
      if (this.event_days == "") {
        this.event_daysEmpty = true;
        return;
      }
      if (this.reg_start_with == "") {
        this.reg_start_withEmpty = true;
        return;
      }
      const formdata = new FormData();

      formdata.append("event_id", this.current_event_id);
      formdata.append("name", this.name);
      formdata.append("code", this.code);
      formdata.append("year", this.year);
      formdata.append("event_type", this.event_type);
      formdata.append("con_exh_type", this.con_exh_type);
      formdata.append("hall_count", this.hall_count);
      formdata.append("max_session_per_day", this.max_session_per_day);
      formdata.append("event_days", this.event_days);
      formdata.append("reg_start_with", this.reg_start_with);
      if (this.kitbag == true) {
        formdata.append("kitbag", "1");
      }
      if (this.certificate == true) {
        formdata.append("certificate", "1");
      }
      if (this.magazine == true) {
        formdata.append("magazine", "1");
      } else {
        formdata.append("magazine", 0);
      }
      if (this.payment == true) {
        formdata.append("payment", "1");
      } else {
        formdata.append("payment", 0);
      }
      if (this.spot_register_info[0] == true) {
        formdata.append("spot_register_info[]", "title");
      }
      if (this.spot_register_info[1] == true) {
        formdata.append("spot_register_info[]", "fullname");
      }
      if (this.spot_register_info[2] == true) {
        formdata.append("spot_register_info[]", "company");
      }
      if (this.spot_register_info[3] == true) {
        formdata.append("spot_register_info[]", "designation");
      }
      if (this.spot_register_info[4] == true) {
        formdata.append("spot_register_info[]", "category");
      }
      if (this.spot_register_info[5] == true) {
        formdata.append("spot_register_info[]", "photo");
      }
      if (this.spot_register_info[6] == true) {
        formdata.append("spot_register_info[]", "city");
      }
      if (this.spot_register_info[7] == true) {
        formdata.append("spot_register_info[]", "mobile");
      }
      if (this.spot_register_info[8] == true) {
        formdata.append("spot_register_info[]", "email");
      }
      console.log(this.spot_register_info);
      console.log("event_co", this.event_codes);
      for (var x = 0; x < this.event_codes.length; x++) {
        if (this.event_codes[x].bfast == true) {
          formdata.append(
            "eventcode[" + x + "][break_fast]",
            this.event_codes[x].bfast_value
          );
        }
        if (this.event_codes[x].lunch == true) {
          formdata.append(
            "eventcode[" + x + "][lunch]",
            this.event_codes[x].lunch_value
          );
        }
        if (this.event_codes[x].dinner == true) {
          formdata.append(
            "eventcode[" + x + "][dinner]",
            this.event_codes[x].dinner_value
          );
        }
        if (this.event_codes[x].other1 == true) {
          formdata.append(
            "eventcode[" + x + "][other_service_1]",
            this.event_codes[x].other1_value
          );
        }
        if (this.event_codes[x].other2 == true) {
          formdata.append(
            "eventcode[" + x + "][other_service_2]",
            this.event_codes[x].other2_value
          );
        }
        console.log("formdata", "eventcode[" + x + "][other_service_2]");
      }

      await axios
        .post(`${this.$store.getters.baseUrl}/event-update`, formdata, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            // this.$swal(
            //   "Success",
            //   "Event category Updated successfully",
            //   "success"
            // );
            this.$swal({
              position: "middle",
              icon: "success",
              title: "Event Basic Details updated successfully",
              timer: 1500,
            });
            this.$router.push({ name: "manage-event" });
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
  },
};
</script>
